import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { RiAddCircleFill, RiLogoutCircleLine } from "react-icons/ri";
import { GiHamburgerMenu } from "react-icons/gi";
// import EdsgLogo from "../../assets/images/SidebarLogo.png";
import EdsgLogo from "../../assets/images/ConnectHealthPro.png";

import useNavigationItems from "../../config/sideBarMenu";
import { usePatient } from "../../contexts/patient";
import { MessageOutlined } from "@mui/icons-material";

const Sidebar = ({ history }) => {
  const {
    setPatientId,
    setPatientInfo,
    setHmoDetails,
    setNurseTypes,
    setPatientName,
  } = usePatient();
  const [hamburger, setHamburger] = useState(true);
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const sidebarRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate
  const userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
  const nuresRole = userInfo?.role[0]?.toLowerCase().replace(/\s+/g, "");

  const ToSupport = () => {
    window.location.href =
      "https://greenzonetechnologies.atlassian.net/servicedesk/customer/portals";
  };

  const logout = async () => {
    const link = localStorage.getItem("homeLink");
    sessionStorage.removeItem("token");
    localStorage.removeItem("USER_INFO");
    localStorage.removeItem("homeLink");
    localStorage.removeItem("LOGIN_TIME");

    navigate("/");
  };

  const resetPatientInfo = () => {
    setPatientInfo(null);
    setPatientId(0);
    setHmoDetails(null);
    setPatientName("");
    setNurseTypes(
      nuresRole === "vitalnurse"
        ? "vital"
        : nuresRole === "nurse"
        ? "admin"
        : "checkin"
    );
  };

  const {
    location: { pathname },
  } = history;

  const navigationItems = useNavigationItems();

  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
    setHamburger(!hamburger);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarVisible(false);
        setHamburger(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {hamburger && (
        <button className="hamburger-menu" onClick={toggleSidebar}>
          <GiHamburgerMenu size={24} />
        </button>
      )}

      <nav
        className={`page-sidebar ${isSidebarVisible ? "visible" : ""}`}
        ref={sidebarRef}
      >
        <div className="sidebar-header">
          <img
            style={{ width: "100%", height: "50px" }}
            src={EdsgLogo}
            alt="logo"
          />
        </div>

        <div className="sidebar-menu">
          <ul className="menu-items">
            {navigationItems &&
              navigationItems.map((item) => (
                <MenuItem
                  key={item.title}
                  item={item}
                  pathname={pathname}
                  resetPatientInfo={resetPatientInfo}
                  navigate={navigate} // Pass navigate prop
                />
              ))}
            {/* <ul> */}
              <li  onClick={()=>navigate('/feedback')} className="pointer"  style={{ marginTop: "20px" }}>
                <MessageOutlined style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />
                {/* <RiLogoutCircleLine className="icon" /> */}
                <span className="title m-l-20 text-wrap">Submit Feedback</span>
              </li>
              <li className="pointer" onClick={logout}  style={{ marginTop: "20px" }}>
                <RiLogoutCircleLine className="icon" />
                <span className="title m-l-20 text-wrap">Log Out</span>
              </li>
            {/* </ul> */}
            {/* <li className="pointer" onClick={logout}>
              <RiLogoutCircleLine className="icon" />
              <span clas
              sName="title m-l-20 text-wrap">Feedback</span>
            </li> */}
          </ul>
        </div>
        <div
          style={{
            bottom: "0%",
            right: "0%",
            position: "fixed",
            zIndex: "1000",
            marginTop: "30px",
            boxShadow: "0px -10px 10px -10px rgba(0, 0, 0, 0.57)",
          }}
        >
          <img
            onClick={ToSupport}
            style={{ width: "180px", height: "120px", cursor: "pointer" }}
            alt="support"
            src="/Support.svg"
          ></img>
        </div>
      </nav>
    </>
  );
};

const MenuItem = ({
  item: { title, href, icon, children, onClick },
  pathname,
  resetPatientInfo,
  navigate,
}) => {
  const [isShowingSub, setIsShowingSub] = useState(false);

  const handleClick = () => {
    if (onClick) onClick();
    setIsShowingSub(!isShowingSub);
    navigate(href);
  };

  const handleClickSub = (href) => {
    if (onClick) onClick();
    if (href && (href.startsWith("http://") || href.startsWith("https://"))) {
      window.location.href = href;
    } else {
      navigate(href);
    }
  };

  return (
    <>
      <li
        className={`${isShowingSub ? "active" : ""} pointer`}
        onClick={handleClick} // Move the click handler to <li>
      >
        {icon}
        {children ? (
          <>
            <span className="has-sub-menu">
              <span className="title m-l-20 text-wrap">{title}</span>
            </span>
            {children && (
              <IoIosArrowBack
                className={`${isShowingSub ? "open" : ""} arrow`}
              />
            )}
          </>
        ) : (
          <span>
            <span className="title m-l-20 text-wrap">{title}</span>
          </span>
        )}
      </li>
      {children && isShowingSub && (
        <ul className={`${isShowingSub ? "show" : ""} sub-menu `}>
          {children &&
            children.map((sub) => (
              <li
                className={`${
                  pathname === sub.href ? "active" : ""
                } pointer m-t-10 m-l-10 m-b-20`}
                key={sub.title}
                onClick={() => handleClickSub(sub.href)}
              >
                {sub.title}
              </li>
            ))}
        </ul>
      )}
    </>
  );
};

export default Sidebar;
